export const config = window.APP_CONFIG;